export default __webpack_public_path__ + "static/DataGirl-ea4672f7a362a0668df7296fa7db77be.png";